/** Reload when a lazy chunk 404s after a deploy (old tab still holds stale asset URLs). */
export function installStaleBundleRecovery(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    window.location.reload();
  });
}
